module.exports = __webpack_public_path__ + "static/media/female.786ca93a.gif";